import React from "react";
import { Column, Table } from "@tanstack/react-table";

// filters of client-side ( with tanstack table)
import ClientStringFilter from "./ClientFilters/StringFilter";
//filters of server-side (with pagination api)
import ServerDateFilter from "./ServerFilters/DateFilter";
import ServerStringFilter from "./ServerFilters/StringFilter";
import ServerSelectFilter from "./ServerFilters/SelectFilter";

/**
 * Filter router component - routes to filter the table data based on column meta
 *
 * Supports two modes:
 * 1. Client-side filtering: Uses TanStack Table's filterFn
 * 2. Server-side filtering: Uses meta.filterVariant and callbacks
 */
const FilterRouter = ({
  table,
  column,
}: {
  table: Table<unknown>;
  column: Column<unknown, unknown>;
}) => {
  const filterVariant = column.columnDef.meta?.filterVariant as
    string | undefined;
  const filterFn = column.columnDef.filterFn as string | undefined;

  const meta = column.columnDef.meta;

  //get the corresponding filter according to configration
  function getFilterComponent(): React.ReactElement | null {
    //first step: check filterVariant
    if (filterVariant) {
      switch (filterVariant) {
        case "serverString": {
          const onChange = meta?.onStringFilterChange;
          if (!onChange) return null;
          return <ServerStringFilter onChange={onChange} />;
        }
        case "serverSelect": {
          const onChange = meta?.onSelectFilterChange;
          const options = meta?.filterOptions;
          if (!onChange || !options) return null;
          return <ServerSelectFilter options={options} onChange={onChange} />;
        }
        case "serverDate": {
          const onChange = meta?.onDateFilterChange;
          if (!onChange) return null;
          return <ServerDateFilter onChange={onChange} />;
        }
        default:
          return null;
      }
    }

    //2nd step: check client filter
    if (filterFn) {
      switch (filterFn) {
        case "includesString":
        case "includesReactElement":
          return <ClientStringFilter column={column} />;
        case "stringTagFilter":
          return (
            <ClientStringFilter
              column={column}
              hoverText={"Nutzen Sie Kommas, um mehrere IDs einzugeben."}
            />
          );
        default:
          return null;
      }
    }
    return null;
  }

  const filterComponent = getFilterComponent();

  if (!filterComponent) {
    return null;
  }

  return (
    <div
      className={
        "d-flex align-items-center p-0 me-3 " + // layout
        "rounded-pill " + // rounded box shape
        "border " + // border
        "overflow-hidden " + // content behaviour
        "cursor-pointer" // pointer
      }
      style={{ height: "30px" }}
    >
      {filterComponent}
    </div>
  );
};

export default FilterRouter;
